import React, {useEffect, useState} from "react";
import {connect, useSelector} from "react-redux";
import Modal from "../../common/Modal/Modal";
import { respondToInvoice } from "../../../actions/invoices";
import Addfiles from "../../common/Addfiles";


export function InvoiceModalToPushPC(props) {

const [includeNotes, setIncludeNotes] = useState(false);
const [notes, setNotes] = useState(null);

const invoice = useSelector(state => state.invoices.invoice);
const messages = useSelector(state => state.messages);

const handleAdjudicate = (e) => {
    e.preventDefault();
    props.handleResponseSubmit({ stage: "PC", notes }, "Invoice successfully closed");
}

useEffect(() => {
    // wait for server response, if update was successful, close modal
    if (messages.length > 0) {
        const lastIndex = messages.length - 1;
        messages[lastIndex].success && props.setPushPCModalOpen(false);
    }
}, [messages]);

const toggleIncludeNotes = (e) => {
    e.preventDefault();
    if (includeNotes) {
        notes && setNotes(null);
        setIncludeNotes(false);
    } else {
        setIncludeNotes(true);
    }
}

const handleCancel = (e) => {
    e.preventDefault();
    props.setPushPCModalOpen(false)
}

    return (
        <div>
            <Modal 
                blurBack={true}
                hideLogo={true}
                hasCloseButton={true}
                handleClose={() => props.setPushPCModalOpen(false)}
            >
                <div className="modal-content">
                    <h1 className="title t-center heavy gap-below-l">Skip to Close Invoice</h1>
                    {invoice.stage == "REV" &&
                        <p className="content1 light-black multiline gap-below-m">&nbsp;&nbsp;&nbsp;&nbsp;If you close the invoice now, you will not have an official record of the purchaser approving the invoice or declaring that payment was sent.</p>
                    }
                    {invoice.stage == "PR" &&
                        <p className="content1 light-black multiline gap-below-m">&nbsp;&nbsp;&nbsp;&nbsp;If you close the invoice now, you will not have an official record of the purchaser declaring that payment was sent.</p>
                    }
                    <p className="content1 light-black multiline gap-below-m">&nbsp;&nbsp;&nbsp;&nbsp;You should only proceed if you are certain you've received payment in full. <span className="heavy">This step cannot be undone.</span></p>
                    <form className="form" onSubmit={(e) => handleAdjudicate(e)}>
                        <div >
                            <Addfiles 
                                uploadTitle="+ Add Supporting Docs"
                                selectedFiles={props.selectedFilesAdditional}
                                handleDrop={props.handleDrop}
                                removeSelectedFile={props.removeSelectedFile}
                                // removeUploadedFile={removeUploadedFileInvoiceAdditional}
                                // removedFiles={removedFilesInvoiceAdditional}
                                maxSize={10485760}
                                maxFiles={0}
                                multiple={true}
                                accept=""
                                textStyle="content2 tb-text"
                            />
                        </div>
                        <button 
                            style={{width: "max-content"}}
                            className={includeNotes ? "content2 light gap-below-xs" : "content2 tb-text"} 
                            onClick={(e) => {
                                e.preventDefault();
                                toggleIncludeNotes(e);
                            }}
                        >
                            {includeNotes ? "- Remove Notes" : "+ Include Notes"}
                        </button>
                        {includeNotes &&
                        <div className="inputs-wrapper gap-below-s">
                            <div className="input-basic textarea ">	
                                <label htmlFor="email">Notes</label>			
                                <textarea
                                    type="text"
                                    name="notes"
                                    onChange={(e) => setNotes(e.target.value)}
                                    id="notes"
                                    rows="3"
                                    required
                                />
                                
                            </div>
                        </div>}
                        <div className="gap-above-m flex-row w100"> 
                            <button className="btn tb iblock expand gap-right-s" type="submit" disabled={props.isSubmitting} >{props.isSubmitting ? "Please wait..." : "Close Invoice"}</button>
                            <button className="btn sec iblock expand" disabled={props.isSubmitting} onClick={(e) => handleCancel(e)} >Cancel</button>
                        </div>
                    </form>
                </div>
            </Modal>
        </div>
    )
}

const mapStateToProps = () => ({});

export default connect(mapStateToProps, {respondToInvoice})(InvoiceModalToPushPC);

